// extracted by mini-css-extract-plugin
export default {"root":"DashboardPage_root__ksT35","menu-button":"DashboardPage_menu-button__6lwAB","body":"DashboardPage_body__ZNA1Y","chart-section":"DashboardPage_chart-section__xU5u-"};